import { useCallback } from 'react';
import { useSiteDetection } from 'shared/hooks/use-site-detection';
import { getOgpSsoEnforced } from 'shared/services/ogp-sign-in-sso/get-company-sso-enforced.service';

export const useCheckCompanyHasSsoEnforced = () => {
  const { site } = useSiteDetection();

  const checkSsoEnforcement = useCallback(
    async (args: { username: string; password: string }) => {
      if (site === 'ogp') {
        const { isOgpSsoEnforced } = await getOgpSsoEnforced(args.username);
        if (isOgpSsoEnforced) {
          throw new Error('SSO is verplicht om je in te loggen voor deze werkgever');
        }
      }
    },
    [site]
  );

  return { checkSsoEnforcement };
};
